import core from './core';
import ClickOut from './mixins/click-out';
import events from '../helpers/events';
import { DeviceManager, MOBILE } from './DeviceManager';
import { Glossary } from '../helpers/Glossary';
import { FixPagePosition } from '../helpers/FixPagePosition';
import { GA4PDPTracker } from './GA4/GA4PDPTracker';
import { TrackingData } from '../helpers/TrackingTypes';

const CustomSelect = core.extend({
	constructor(options) {
		this.config = { classOpen: 'open' };

		this.$ = {};
		this.$.el = jQuery(options.el);
		jQuery.extend(true, this.config, options || {});

		this.init();

		events(this);

		this.pagePosition = 0;

		this.selectedValue = '';

		this.deviceManager = new DeviceManager();
	},

	init() {
		this.attachEvents();
	},

	getSelectedOpt(el) {
		return el.hasClass('option') ? el.html() : el.find('.option').html();
	},

	getValue(el) {
		return el.hasClass('option') ? el.data('value') : el.find('.option').data('value');
	},

	setSelectedOpt(select, opt, val) {
		select.find('.selected-option').html(opt).attr('data-option', val);
	},

	scrollDropdownToSelectedOption(selector) {
		const selectedOption = selector.find('.selected');
		const selectedOptionIsDefault = selectedOption.data('quantity') === Glossary.DEFAULT_ITEMS;

		if (selectedOption.length === 0 || selectedOptionIsDefault) {
			return;
		}

		const dropdown = selector.find('.js-options-list');

		let scrollPosition;

		if (this.deviceManager.getCurrentState() === MOBILE) {
			const mobileLabel = selector.find('.js-mobile-label');

			scrollPosition = -(mobileLabel.outerHeight() - selectedOption.offset().top + selectedOption.outerHeight());
		} else {
			scrollPosition = -(selector.offset().top - selectedOption.offset().top + selectedOption.outerHeight() * 2); // number 2 is needed to show selected element on the second place when dropdown is opened
		}

		dropdown.scrollTop(scrollPosition);
	},

	scrollDropdownToTop() {
		let dropdown;

		this.$.el.each((index, el) => {
			const isDropdownOpened = el.classList.contains(this.config.classOpen);

			if (isDropdownOpened) {
				dropdown = el;
			}
		});

		jQuery(dropdown).find('.js-options-list').scrollTop(0);
	},

	attachEvents() {
		this.clickOut(this.config.el, function () {
			this.scrollDropdownToTop();
		}); // className, callBack

		jQuery(document).off('click', `${this.config.el} .select-options li`).off('click', this.config.el);

		jQuery(document)
			.on('click', `${this.config.el} .select-options li`, (e) => {
				e.stopPropagation();
				const el = jQuery(e.currentTarget);
				const select = el.parents('.customized');
				const selectedOpt = this.getSelectedOpt(el);
				const selectedVal = this.getValue(el);

				if (
					el.hasClass('is-disabled') ||
					el.hasClass('is-disabled-because-refinement') ||
					el.hasClass('is-disabled-because-frame')
				) {
					return;
				}

				this.scrollDropdownToTop();

				select.removeClass(this.config.classOpen);

				if (this.deviceManager.getCurrentState() === MOBILE && this.config.forbidPageScroll) {
					FixPagePosition.getInstance().unregisterComponent(this);
				}

				if (!selectedVal) {
					return;
				}

				if (this.selectedValue !== selectedVal) {
					this.publish('select:changed', {
						selectedValue: selectedVal,
						element: el,
					});
				}

				this.setSelectedOpt(select, selectedOpt, selectedVal);
			})
			.on('click', this.config.el, (e) => {
				e.preventDefault();
				e.stopPropagation();

				const el = jQuery(e.currentTarget);

				if (this.config.trackingCategory && this.config.trackingCategory === TrackingData.PAGE_PDP) {
					GA4PDPTracker.trackDropdownOptionField(e.currentTarget.dataset.type);
				}

				this.selectedValue = this.getValue($(el).find('.selected'));

				if (!el.parents('.one-option').length) {
					if (this.deviceManager.getCurrentState() === MOBILE && this.config.forbidPageScroll) {
						if (el.hasClass(this.config.classOpen)) {
							FixPagePosition.getInstance().unregisterComponent(this);
						} else {
							FixPagePosition.getInstance().registerComponent(this);
						}
					}

					if (el.hasClass(this.config.classOpen)) {
						this.scrollDropdownToTop();
						el.removeClass(this.config.classOpen);
					} else {
						el.addClass(this.config.classOpen);
						this.scrollDropdownToSelectedOption(el);
					}

					this.$.el.not(e.currentTarget).removeClass(this.config.classOpen);
				}
			});
	},
});

CustomSelect.include(ClickOut);

export default CustomSelect;
